import React from 'react';
import { VsmSymbolId } from '../../data/vsmSymbols';
import { VSM_ICON_MARKUP } from '../../data/vsmIconMarkup';
import { NotationSymbolIcon } from './NotationSymbolIcon';

interface VsmSymbolIconProps {
  symbolId: VsmSymbolId;
  size?: number;
  className?: string;
}

export const VsmSymbolIcon: React.FC<VsmSymbolIconProps> = ({ symbolId, size, className }) => {
  const icon = VSM_ICON_MARKUP[symbolId];
  if (!icon) return null;

  const fillParent = Boolean(className?.includes('w-full') || className?.includes('h-full'));

  return (
    <NotationSymbolIcon
      viewBox={icon.viewBox}
      markup={icon.markup}
      size={fillParent ? undefined : size ?? 40}
      className={className ?? (fillParent ? 'w-full h-full' : undefined)}
      idPrefix={`vsm-${symbolId}`}
      stretch={false}
    />
  );
};

export default VsmSymbolIcon;
